import { getViewPermission } from '../helpers';
import { jsonResponseHandling } from '../fetch';
import { apiUrl, FLEET_PATH, fetchWithSubscriptionKey } from '../api-manager';

const VEHICLES_PATH = `${FLEET_PATH}/vehicles`;

export const fetchBuses = async () => {
    const api = apiUrl(`${VEHICLES_PATH}?type=bus`);
    return fetchWithSubscriptionKey(api, { method: 'GET' }).then(response => jsonResponseHandling(response));
};

export const fetchFerries = async () => {
    const api = apiUrl(`${VEHICLES_PATH}?type=ferry`);
    return fetchWithSubscriptionKey(api, { method: 'GET' }).then(response => jsonResponseHandling(response));
};

export const fetchTrains = async () => {
    const api = apiUrl(`${VEHICLES_PATH}?type=train`);
    return fetchWithSubscriptionKey(api, { method: 'GET' }).then(response => jsonResponseHandling(response));
};

export const getFleetsViewPermission = () => getViewPermission(apiUrl(VEHICLES_PATH));

export const getFleets = async () => {
    const api = apiUrl(VEHICLES_PATH);
    return fetchWithSubscriptionKey(api, { method: 'GET' }).then(response => jsonResponseHandling(response));
};
